import { render, staticRenderFns } from "./ViewOne.vue?vue&type=template&id=36d8dba0&"
import script from "./ViewOne.vue?vue&type=script&lang=js&"
export * from "./ViewOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports